// extracted by mini-css-extract-plugin
export var disabledOption = "_redotech-redo-web-src-autocomplete-disabled-option";
export var dropdownItemWrapper = "_redotech-redo-web-src-autocomplete-dropdown-item-wrapper";